export enum CancelationExplanationDialogMaxLenghtsEnum {
  REASON_EXPLANATION = 500,
}
